<template>
  <b-container fluid>
    <b-alert
      :show="dismissCountDown"
      dismissible
      variant="info"
      style="margin-top:5px;"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      <h4 class="alert-heading">
        {{ clickedWord.text }}
      </h4>
            
      <p v-if="clickedWord.value==1">
        Out of {{ itemCount }} tasks, <b>{{ clickedWord.text }}</b> appeared {{ clickedWord.value }} time ({{ clickedWord.percent }}%)
      </p>

      <p v-else>
        Out of {{ itemCount }} tasks, <b>{{ clickedWord.text }}</b> appeared {{ clickedWord.value }} times ({{ clickedWord.percent }}%)
      </p>
            
      <b-progress
        variant="warning"
        :max="dismissSecs"
        :value="dismissCountDown"
        height="4px"
      />
    </b-alert>

    <b-row style="margin-top:5px;">
      <b-col>
        Completed
      </b-col>

      <b-col>
        Date
      </b-col>

      <b-col>
        From
      </b-col>

      <b-col>
        To
      </b-col>
    </b-row>

    <b-row style="margin-top:5px;">
      <b-col>
        <b-form-select
          v-model="taskAnalyticsFilter.completed"
          :options="yesorno"
          value-field="item"
          text-field="name"
        />
      </b-col>
            
      <b-col>
        <b-form-select
          v-model="taskAnalyticsFilter.dateField"
          :options="dateFields"
          value-field="item"
          text-field="name"
        />
      </b-col>

      <b-col>
        <input
          id="start"
          v-model="taskAnalyticsFilter.startDateBegin"
          type="date"
          class="form-control form-control-sm"
        >
      </b-col>

      <b-col>
        <input
          id="start"
          v-model="taskAnalyticsFilter.startDateEnd"
          type="date"
          class="form-control form-control-sm"
        >
      </b-col>
    </b-row>

    <b-row
      class="justify-content-center"
      style="margin-top:5px;"
    >
      <b-button @click="getData">
        Load
      </b-button>
    </b-row>


    <b-row
      v-if="$store.getters.getUserLoading"
      class="justify-content-center"
    >
      <b-spinner
        :style="{visibility: $store.getters.getUserLoading ? 'visible' : 'hidden'}"
        label="Spinning"
      />
      <b-spinner
        :style="{visibility: $store.getters.getUserLoading ? 'visible' : 'hidden'}"
        type="grow"
        label="Spinning"
      />
      <b-spinner
        :style="{visibility: $store.getters.getUserLoading ? 'visible' : 'hidden'}"
        variant="primary"
        label="Spinning"
      />
      <b-spinner
        :style="{visibility: $store.getters.getUserLoading ? 'visible' : 'hidden'}"
        variant="primary"
        type="grow"
        label="Spinning"
      />
      <b-spinner
        :style="{visibility: $store.getters.getUserLoading ? 'visible' : 'hidden'}"
        variant="success"
        label="Spinning"
      />
      <b-spinner
        :style="{visibility: $store.getters.getUserLoading ? 'visible' : 'hidden'}"
        variant="success"
        type="grow"
        label="Spinning"
      />
    </b-row>
        
    <b-row
      align-h="around"
      class="pt-5"
    >
      <b-col cols="6">
        <GChart
          type="PieChart"
          :data="chartData"
          :options="chartOptions.chart"
        />
      </b-col>

      <b-col cols="6">
        <b-table 
          striped 
          hover 
          :items="taskWords"
                    
          sort-by="text"
        />
      </b-col>
    </b-row>

    <b-row align-h="around" />
  </b-container>
</template>

<script>


import AnalyticsService from '../services/AnalyticsService'
import { GChart } from 'vue-google-charts'
import TaskService from '../services/TaskService';
import taskOps from '../mixins/taskOps'
import genericOps from '../mixins/genericOps'

export default {
    name: 'WordCloud',
    components: {
        GChart,
    },
    mixins: [taskOps, genericOps],
    props: {

    },
    data () {
        return {
            now: Date.now(),
            chartData: [
                ['Year', 'Sales', 'Expenses', 'Profit'],
                ['2014', 1000, 400, 200],
                ['2015', 1170, 460, 250],
                ['2016', 660, 1120, 300],
                ['2017', 1030, 540, 350]
            ],
            chartOptions: {
                chart: {
                    width:600,
                    height:600,
                    legend: {
                        position:'none'
                    },
                    chartArea: {
                        left:0,
                        top:15,
                        width:'auto',
                        height:'auto'
                    },
                    pieHole: .25,
                    sliceVisibilityThreshold: .05
                }
            },
            dateField: [
                {
                    name: 'Start Date',
                    item: 'start'
                },
                {
                    name: 'Due Date',
                    item: 'due'
                }
            ],
            taskAnalyticsFilter: {},
            taskWords: [],
            fontSizeMapper: word => Math.log2(word.value) * 5,
            awaitingSearch: false,
            dismissSecs: 10,
            dismissCountDown: 0,
            showDismissibleAlert: false,
            clickedWord: {},
            itemCount: 0
        }
    },
    created() {
        
        //var moment = require('moment')
        
        //var begin = moment().subtract(7, 'day')
        //var end = moment()
        
        this.taskAnalyticsFilter.completed = 'Y',
        this.taskAnalyticsFilter.dateField = 'due'
        this.taskAnalyticsFilter.startDateBegin = '2019-01-01'
        this.taskAnalyticsFilter.startDateEnd = '2019-12-31'
    },
    methods: {
        wordClicked(word) {
            this.clickedWord = word
            this.dismissCountDown = this.dismissSecs            
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        async getData() {
            
            let tempWords = Array
            
            try {
                
                this.awaitingSearch = true

                let tempFilter = Object.assign({}, this.taskAnalyticsFilter)

                if(!(typeof tempFilter.startDateBegin == 'undefined' || tempFilter.startDateEnd === null)) {
                    
                    let gt = TaskService.getMillisFromString(tempFilter.startDateBegin)
                    let lt = TaskService.getMillisFromString(tempFilter.startDateEnd)
                    
                    //////console.log(gt + ' > start < ' + lt)

                    //tempFilter.start = { $gt: gt, $lt: lt}

                    tempFilter.$and = [
                        {[tempFilter.dateField]: {$gte: gt}},
                        {[tempFilter.dateField]: {$lte: lt}}
                    ]

                    
                }

                delete tempFilter['startDateBegin'];
                delete tempFilter['startDateEnd'];
                delete tempFilter['dueDateBegin'];
                delete tempFilter['dueDateEnd'];
                delete tempFilter['dateField'];

                //////console.log('Original Filter set to: ' + JSON.stringify(this.taskAnalyticsFilter))
                //////console.log('Filter set to: ' + JSON.stringify(tempFilter))
                
                tempWords = await AnalyticsService.getCloudWords(this.$store.getters.getUser._id, tempFilter, this.$store.getters.getUserToken)
                //////console.log(JSON.stringify(tempWords))
                
                this.taskWords = []
                
                this.itemCount = 0;

                for(let i = 0; i < tempWords.length; i++) {
                    this.itemCount += tempWords[i].folder_count
                }

                //////console.log(this.itemCount + ' task(s) in ' + tempWords.length + ' item(s)')

                this.chartData = []
                
                this.taskWords = tempWords.map(item => {
                    
                    let container = {};

                    container.text = (typeof item._id == 'undefined' || item._id === null || item._id == '') ? 'Unassigned' : item._id
                    container.value = item.folder_count
                    container.percent = Math.round((container.value/this.itemCount) * 100)
  
                    return container;
                })

                this.chartData = tempWords.map(item => {
                    
                    let container = [];

                    container[0] = (typeof item._id == 'undefined' || item._id === null || item._id == '') ? 'Unassigned' : item._id
                    container[1] = item.folder_count
                    container[2] = Math.round((container.value/this.itemCount) * 100)
  
                    return container;
                })

                this.chartData.unshift(['Folder', 'Number', 'Perecent'])

                /*
                for(let i = 0; i < tempWords.length; i++) {
                    



                    this.taskWords.unshift({
                        text: (typeof tempWords[i]._id == 'undefined' || tempWords[i]._id === null || tempWords[i]._id == '') ? 'Unassigned' : tempWords[i]._id, 
                        value: tempWords[i].folder_count,
                        percent: 'add_me'
                        })

                    

                    
                }
                */

                //////console.log('Have ' + this.taskWords.length + " word(s) to display")
                

            } catch(e) {
                //////console.log('Error getting words for cloud: ' + e)
            }


        }
    }
}
</script>

<style scoped>
    svg {
        align-content: center;
        border: 2px solid #000000;
        height: 200px;
        width: 200px;
    }
    g {
        align-content: center;
    }
</style>